import PasswordValidator from 'password-validator';

// The longest password the rule allows; the password fields stop typing here (components/Forms/components/Input.tsx).
export const PASSWORD_MAX_LENGTH = 100;

const passwordSchema = new PasswordValidator();

// Configuración del esquema de validación de contraseñas
passwordSchema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(PASSWORD_MAX_LENGTH) // Maximum length 100
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits(2) // Must have at least 2 digits
  .has()
  .not()
  .spaces() // Should not have spaces
  .is()
  .not()
  .oneOf(['Passw0rd', 'Password123']); // Blacklist these values

export default passwordSchema;
